/* istanbul ignore file */
// @todo tymofiih@wix.com research enzyme render issue

import React from 'react';
import {Button, ButtonPriority, HoverStyles} from '@wix/wix-ui-tpa/cssVars';
import {ProvidedGlobalProps, withGlobalProps} from '../../../providers/globalPropsProvider';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import BackInStockButtonStyles from './BackInStockButton.scss';
import {classes as backInStockButtonClasses} from './BackInStockButton.st.css';
import classNames from 'classnames';

interface BackInStockButtonInterface extends ProvidedGlobalProps, IProvidedTranslationProps {}

interface BackInStockButtonState {
  showError: boolean;
}

export enum BackInStockButtonDataHook {
  Root = 'BackInStockButton.Root',
}

class BackInStockButtonComponent extends React.Component<BackInStockButtonInterface, BackInStockButtonState> {
  private createNotification() {
    this.props.globals.handleNotifyWhenBackInStock();
  }

  private getClasses() {
    const {shouldShowWishlistButton} = this.props.globals;
    return classNames(BackInStockButtonStyles.backInStockButton, backInStockButtonClasses.backInStockButton, {
      [BackInStockButtonStyles.primaryButton]: shouldShowWishlistButton,
      [BackInStockButtonStyles.fullWidth]: !shouldShowWishlistButton,
    });
  }

  public render() {
    return (
      <Button
        data-hook={BackInStockButtonDataHook.Root}
        onClick={() => {
          this.createNotification();
        }}
        className={this.getClasses()}
        hoverStyle={HoverStyles.underline}
        priority={ButtonPriority.primary}>
        {this.props.t('productPage.backInStock.notifyWhenAvailable.button')}
      </Button>
    );
  }
}

export const BackInStockButton = withGlobalProps(withTranslations('globals.texts')(BackInStockButtonComponent));
